module.exports = __webpack_public_path__ + "assets/img/media_29.de652cd3.png";